export class MosError extends Error {
  public statusCode: number;
  public errorCode?: string;
  public rawBody?: unknown;
  constructor(body: {
    error?: string;
    message?: string;
    statusCode?: number;
    errorCode?: string;
    rawBody?: unknown;
  }) {
    super(body.error ?? 'UnknownError');
    this.name = 'MosError';
    this.message = body.message ?? '';
    this.statusCode = body.statusCode ?? 0;
    this.errorCode = body.errorCode;
    this.rawBody = body.rawBody;
  }
}
